import AccountLayout from "@/components/layouts/account-layout";
import { renderAccountView } from "@/components/templates/Account/account-templates/render-account-view";
import { resolveSegmentKey } from "@/helpers/templates";
import { notFound } from "next/navigation";

const checkRoutes = (resolutions: Resolution) => {
  if (!resolutions.isArchive) {
    const test = resolveSegmentKey(resolutions.locale, resolutions.slugs[0], true);

    if (!test) return false;
  }

  return true;
};

const Account = ({ resolution }: TemplateProps) => {
  if (!checkRoutes(resolution)) return notFound();

  const viewComponent = renderAccountView(resolution);

  if (viewComponent === null) return notFound();

  return <AccountLayout resolution={resolution}>{viewComponent}</AccountLayout>;
};

export default Account;
